import { useEffect, useState } from 'react'
import { uniqueId } from 'lodash'
import filesize from 'filesize'
import {Button,Divider} from 'semantic-ui-react'
import { api } from '../../services/api'
import UploadFile from '../UploadFile'
import FileList from '../FileList'
import IsAudity from '../IsAudity'
import { FooterContainer, ButtonsContainer, CleanButton } from './styles'


export default function ProcessFile(props){
    const [uploadedFiles, setUploadedFiles] = useState([])
    const [isAudity, setIsAudity] = useState(false)
    const [buttonStatus, setButtonStatus] = useState({
        loading: false,
        disabled: true
    })

    useEffect(() => {
        if(!buttonStatus.loading){
            const hasFiles = uploadedFiles.length === 0

            setButtonStatus(prev => ({...prev, disabled: hasFiles}))
        }
    }, [uploadedFiles])

    function addFilesToUpload(files) {
        const uploadedFiles = files.map(file => ({
            file,
            id: uniqueId(),
            name: file.name,
            readableSize: filesize(file.size),
            removable: true,
            inProcess: false,
            success: false,
            error: false,
            errorDescription: ''
        }))

        setUploadedFiles(uploadedFiles)
    }

    function processStart(){
        setButtonStatus(prev => ({
            ...prev, 
            loading: true,
            disabled: true,
        }))
    }

    function processFinish(successCount){
        setButtonStatus(prev => ({
            ...prev, 
            loading: false,
            disabled: true,
        }))
    }

    function removeFile(fileId){
        setUploadedFiles(prev => prev.filter(file => file.id !== fileId))
    }

    function updateFileStatus(id, status) {
        setUploadedFiles(prev => prev.map(file => file.id === id ? {...file, ...status} : file))
    }

    async function uploadAllFiles(){
        processStart()

        setUploadedFiles(prev => prev.map(f => ({ ...f, inProcess: true, removable: false })))

        const promises = uploadedFiles.map(file => {
            const formData = new FormData()
            formData.append('file', file.file, Date.now() + '.pptx')
            formData.append('isAudity', isAudity)
            formData.append('originalFilename', file.name)

            return api.post('/ppt/process', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            }).then(response => {
                updateFileStatus(
                    file.id, 
                    { 
                        inProcess: false, 
                        success: true, 
                        error: false,
                        downloadLink: response.data.downloadLink
                    }
                )

                return response
            }).catch((err) => {
                updateFileStatus(
                    file.id, 
                    { 
                        inProcess: false, 
                        success: false, 
                        error: true, 
                        errorDescription: err.response?.data.message
                    }
                )

                return null
            })
        })

        const results = await Promise.all(promises)
        const success = results.filter(r => r !== null)

        processFinish(success.length)
    }

    async function handleAudity(element, {checked}){
        setIsAudity(checked)
    }

    function cleanProcess(){
        setUploadedFiles([])
        setButtonStatus({
            loading: false,
            disabled: true
        })
    }

    function downloadFile(file) {
        const link = document.createElement('a')
        link.href = file.downloadLink
        link.download = file.name
        link.click()
    }

    return(
        <>
            <UploadFile process={addFilesToUpload}/>
            { 
                !!uploadedFiles.length && 
                <FileList files={uploadedFiles} removeFile={removeFile} downloadFile={downloadFile}/>
            }
            <Divider/>
            <FooterContainer>
                <IsAudity handleAudity={handleAudity}/>
                <ButtonsContainer>
                    <Button 
                        primary
                        disabled={buttonStatus.disabled}
                        loading={buttonStatus.loading} 
                        onClick={() => uploadAllFiles()}
                    >Enviar</Button>
                    {
                        !!uploadedFiles.length && !buttonStatus.loading && (
                            <CleanButton onClick={cleanProcess}>Limpar</CleanButton>
                        )
                    }
                </ButtonsContainer>
            </FooterContainer>
        </>
    )
}